export default __webpack_public_path__ + "static/media/pre-op-1.d1a91a17.jpg";